import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

export interface CreateMappingActivityPayload {
  start_date: string
  end_date: string
  diagnosis_name: string
  description: string
  culture: Culture
  treatment: Treatment
}

export async function createMappingActivity(
  payload: CreateMappingActivityPayload,
): Promise<void> {
  await companiesApi.post(apiRoutes.createMappingActivity, payload)
}
